import _ from "lodash"

/**
 * Basically a search function that convert a View selection rows
 * into its data index from the data model.
 * @param dataView a view that can be ordered differently from the model
 * @param dataModel a data model from server side
 * @returns {{data: [{dataIndex: *}]}}
 */
// eslint-disable-next-line import/prefer-default-export
export function findDataIdx(dataView, dataModel) {
  const predicate = (it) => it._id === dataView.rowData[0]
  // 0 is ID
  const dataIndex = _.findIndex(dataModel, predicate)
  return { data: [{ dataIndex }] }
}

// FIXME SR : this is a performance issue, because of usage of #findDataIdx
// Fix it using a more appropriate data structure like object map
export function findModel(dataView, dataModel) {
  const dataIndex = findDataIdx(dataView, dataModel)
  const indexInteger = dataIndex.data[0].dataIndex
  return dataModel[indexInteger]
}
